import { Pipe, PipeTransform } from '@angular/core';
import { CommonService } from '../../core/services/v2/common.service';
import { CodeTable } from '../../core/model/v2/code-table';

@Pipe({
  name: 'getValueForCode'
})
export class GetValueForCodePipe implements PipeTransform {

  constructor(private commonService: CommonService) { }

  transform(value: any, group: string): string {
    if (!value) return '';
    let codeVal: string;
    let codes = this.commonService.getItemCodesFiltered(group);
    if (!codes) return '';

    codes.codeItemTables.forEach(tableEle => {
      if (tableEle.itemValue === value) {
        codeVal = tableEle.itemDescription;
      }
    });

    return codeVal;
  }

}
